"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useMemo } from "react";
import { useJoyride } from "react-joyride";
import { TourBeacon } from "@/features/onboarding-tours/components/tour-beacon";
import { TourLoader } from "@/features/onboarding-tours/components/tour-loader";
import { TourTooltip } from "@/features/onboarding-tours/components/tour-tooltip";
import type { useTourSession } from "@/features/onboarding-tours/context/use-tour-session";
import { createTourJoyrideOptions, readTourJoyridePrimaryColor, readTourJoyrideSurfaceColor, tourJoyrideLocale } from "@/features/onboarding-tours/lib/tour-joyride-theme";
import { useKeepTourJoyridePortalInteractive } from "@/features/onboarding-tours/lib/use-keep-tour-joyride-portal-interactive";
interface TourJoyrideShellProps {
  session: ReturnType<typeof useTourSession>;
}
export function TourJoyrideShell(t0) {
  const $ = _c(12);
  const {
    session
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = readTourJoyridePrimaryColor();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const primaryColor = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = readTourJoyrideSurfaceColor();
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const surfaceColor = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = createTourJoyrideOptions({
      primaryColor,
      surfaceColor
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const joyrideOptions = t3;
  let t4;
  if ($[3] !== session.run) {
    t4 = {
      enabled: session.run
    };
    $[3] = session.run;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useKeepTourJoyridePortalInteractive(t4);
  let t5;
  if ($[5] !== session.handleJoyrideEvent || $[6] !== session.run || $[7] !== session.steps) {
    t5 = {
      beaconComponent: TourBeacon,
      continuous: true,
      loaderComponent: TourLoader,
      locale: tourJoyrideLocale,
      onEvent: session.handleJoyrideEvent,
      options: joyrideOptions,
      run: session.run,
      scrollToFirstStep: false,
      steps: session.steps,
      tooltipComponent: TourTooltip
    };
    $[5] = session.handleJoyrideEvent;
    $[6] = session.run;
    $[7] = session.steps;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    Tour
  } = useJoyride(t5);
  const t6 = session.activeTourId ?? "tour-idle";
  const t7 = Tour ?? null;
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <div key={t6} suppressHydrationWarning={true}>{t7}</div>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}